export const FEATURED_SCROLLID = 'FEATURED_SCROLLID';
export const VIDEO_SCROLLID = 'VIDEO_SCROLLID';
export const FOOTER_VIDEO_SCROLLID = 'FOOTER_VIDEO_SCROLLID';
export const COLOR_GRAY = '#656565';

// YouTube URLs
export const YOUTUBE_VIDEO_URL = 'https://www.youtube.com/watch?v=kWnyT_ZeEF4';
export const YOUTUBE_VIDEO_ID = 'kWnyT_ZeEF4';

// Helper function to convert YouTube watch URL to embed URL
export const getYouTubeEmbedUrl = (videoId, options = {}) => {
  const { autoplay = 1, mute = 1, loop = 1, controls = 0, showinfo = 0, rel = 0, modestbranding = 1 } = options;

  return `https://www.youtube.com/embed/${videoId}?autoplay=${autoplay}&mute=${mute}&loop=${loop}&playlist=${videoId}&controls=${controls}&showinfo=${showinfo}&rel=${rel}&modestbranding=${modestbranding}`;
};
